// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/export_template.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateExportTemplateRequest, DeleteExportTemplateRequest, ExportClientCatalogRequest, ExportClientCatalogResponse, ExportOrderRequest, ExportOrderResponse, ExportTemplate, GetDefaultExportColumnsRequest, GetDefaultExportColumnsResponse, GetExportTemplateRequest, ListExportTemplatesRequest, ListExportTemplatesResponse, ParseTemplateFromMediaRequest, ParseTemplateFromMediaResponse, PreviewExportTemplateRequest, PreviewExportTemplateResponse, UpdateExportTemplateRequest } from "./export_template_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.ExportTemplateService
 */
export const ExportTemplateService = {
  typeName: "omnios.v1.ExportTemplateService",
  methods: {
    /**
     * @generated from rpc omnios.v1.ExportTemplateService.CreateExportTemplate
     */
    createExportTemplate: {
      name: "CreateExportTemplate",
      I: CreateExportTemplateRequest,
      O: ExportTemplate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ExportTemplateService.GetExportTemplate
     */
    getExportTemplate: {
      name: "GetExportTemplate",
      I: GetExportTemplateRequest,
      O: ExportTemplate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ExportTemplateService.UpdateExportTemplate
     */
    updateExportTemplate: {
      name: "UpdateExportTemplate",
      I: UpdateExportTemplateRequest,
      O: ExportTemplate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ExportTemplateService.DeleteExportTemplate
     */
    deleteExportTemplate: {
      name: "DeleteExportTemplate",
      I: DeleteExportTemplateRequest,
      O: ExportTemplate,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ExportTemplateService.ListExportTemplates
     */
    listExportTemplates: {
      name: "ListExportTemplates",
      I: ListExportTemplatesRequest,
      O: ListExportTemplatesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ExportTemplateService.ExportOrder
     */
    exportOrder: {
      name: "ExportOrder",
      I: ExportOrderRequest,
      O: ExportOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ExportTemplateService.ExportClientCatalog
     */
    exportClientCatalog: {
      name: "ExportClientCatalog",
      I: ExportClientCatalogRequest,
      O: ExportClientCatalogResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ExportTemplateService.PreviewExportTemplate
     */
    previewExportTemplate: {
      name: "PreviewExportTemplate",
      I: PreviewExportTemplateRequest,
      O: PreviewExportTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns locale-aware default columns (uses accept-language header)
     *
     * @generated from rpc omnios.v1.ExportTemplateService.GetDefaultExportColumns
     */
    getDefaultExportColumns: {
      name: "GetDefaultExportColumns",
      I: GetDefaultExportColumnsRequest,
      O: GetDefaultExportColumnsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Parse an uploaded XLSX/CSV (referenced by media_id) and
     * infer column definitions from its header row.
     *
     * @generated from rpc omnios.v1.ExportTemplateService.ParseTemplateFromMedia
     */
    parseTemplateFromMedia: {
      name: "ParseTemplateFromMedia",
      I: ParseTemplateFromMediaRequest,
      O: ParseTemplateFromMediaResponse,
      kind: MethodKind.Unary,
    },
  }
};

